import { useMsal } from "@azure/msal-react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DownloadIcon from '@mui/icons-material/Download';
import {
    Box,
    List,
    ListItem,
    Modal,
    Popover,
    TextField,
    Typography,
    Button,
    Alert,
    Chip,
    Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampaignDesigns, assignDesigner } from "../Redux/CampaignDesignSlice";
import "./DesignTable.css";
import axios from "axios";
import { baseURL } from "../Constant";

const CustomFooter = () => <div></div>;

const CampaignDesignTable = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    let loggedInEnterpriseId = activeAccount?.idTokenClaims?.enterpriseID || "";

    const { designs, fetchLoading } = useSelector((state) => state.campaignDesign);

    const [rows, setRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [currentColumn, setCurrentColumn] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [modalRecord, setModalRecord] = useState(null);
    const [sortModel, setSortModel] = useState([{ field: "created_at", sort: "desc" }]);
    const [downloadingFile, setDownloadingFile] = useState(null);
        const [toast, setToast] = useState({
        open: false,
        message: "",
        severity: "success", // success | error | warning | info
    });


    const [openAssignModal, setOpenAssignModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedDesigner, setSelectedDesigner] = useState("");
    const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
    const designerList = userData?.filter((user) => user.Designer === 'yes'); //list of all designers from user-maintenance

    useEffect(() => {
        dispatch(fetchCampaignDesigns());
    }, []);

    useEffect(() => {
        if (designs?.length > 0) {
            setRows(designs);
        }
    }, [designs]);

    // Filter logic

    let filteredOptions;
    if (currentColumn) {
        filteredOptions = Array.from(
            new Set(designs?.map((row) => row[currentColumn]))
        ).filter(
            (value) =>
                value != null &&
                value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
    } else {
        filteredOptions = [];
    }

    const handleAssign = (row) => {
        setSelectedRow(row);
        setOpenAssignModal(true);
    };

    const { assignLoading } = useSelector((state) => state.campaignDesign);

    const handleAssignSubmit = async () => {
        if (!selectedDesigner) {
            showToast("Please select a designer", "warning");
            return;
        }

        try {
            await dispatch(assignDesigner({
                campaignId: selectedRow.id,
                designerId: selectedDesigner,
                assignedBy: loggedInEnterpriseId
            })).unwrap();

            showToast("Designer assigned successfully", "success");

            setOpenAssignModal(false);
            setSelectedDesigner("");

            // refresh table
            dispatch(fetchCampaignDesigns());

        } catch (err) {
            console.error(err);
            showToast("Failed to assign designer", "error");
        }
    };

    const handleFilterClick = (event, column) => {
        setCurrentColumn(column);
        setAnchorEl(event.currentTarget);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setCurrentColumn(null);
        setSearchTerm("");
    };

    const handleAction = async (id, status) => {
        const confirmMsg =
            status === "approved"
                ? "Are you sure you want to APPROVE this request?"
                : "Are you sure you want to REJECT this request?";

        const confirmed = window.confirm(confirmMsg);

        if (!confirmed) {
            const radios = document.getElementsByName(`action-${id}`);
            radios.forEach(r => (r.checked = false));
            return;
        }

        try {
            await axios.post(`${baseURL}/campaign-design/update-status`, {
                id,
                status,
                approver: loggedInEnterpriseId
            });

            showToast(`Request ${status}`, "success");
            dispatch(fetchCampaignDesigns());
        } catch (err) {
            console.error(err);
            showToast("Failed to update status", "error");
        }
    };

    const handleSelection = (value, isSelected) => {
        let newSelectedFilters = { ...selectedFilters };

        if (!newSelectedFilters[currentColumn]) {
            newSelectedFilters[currentColumn] = [value];
        } else if (isSelected) {
            newSelectedFilters[currentColumn] = newSelectedFilters[currentColumn].filter(
                (item) => item !== value
            );
        } else {
            newSelectedFilters[currentColumn] = [
                ...newSelectedFilters[currentColumn],
                value,
            ];
        }

        setSelectedFilters(newSelectedFilters);

        let filteredRows = designs;
        Object.keys(newSelectedFilters).forEach((column) => {
            if (newSelectedFilters[column]?.length > 0) {
                filteredRows = filteredRows.filter((row) =>
                    newSelectedFilters[column].includes(row[column])
                );
            }
        });

        setRows(filteredRows);
    };

    const handleReset = () => {
        setSelectedFilters({});
        setRows(designs);
        handleFilterClose();
    };

    const clearFilters = () => {
        setSelectedFilters({});
        setRows(designs);
    };

    // Modal

    const handleOpen = (record) => {
        setOpenModal(true);
        setModalRecord(record);
    };

    const handleClose = () => {
        setOpenModal(false);
        setModalRecord(null);
    };

    // File download

    function triggerDownload(url, fileName) {
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const handleDownload = (filePath, fileName) => {
        const url = `${baseURL}/download-file?filePath=${encodeURIComponent(filePath)}`;

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    // Columns
    const columns = [
        {
            field: "id",
            headerName: <div style={{ display: "flex", paddingLeft: "10px" }}>SI#</div>,
            minWidth: 60,
            sortable: false,
            flex: 0.4,
            renderCell: (params) =>
                params.api.getSortedRowIds().indexOf(params.id) + 1,
            headerClassName: "left-align-header",
            cellClassName: "left-cell",
        },
        {
            field: "market",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Market
                    <FilterAltIcon
                        style={{ width: "15px", marginTop: "3px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "market")}
                    />
                </div>
            ),
            minWidth: 110,
            sortable: false,
            flex: 1,
            headerClassName: "center-header",
            cellClassName: "left-cell",
        },
        {
            field: "program_name",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Program Name
                    <SearchIcon
                        style={{ width: "15px", marginTop: "3px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "program_name")}
                    />
                </div>
            ),
            minWidth: 160,
            sortable: true,
            flex: 1,
            headerClassName: "center-header",
            cellClassName: "left-cell",
        },
        {
            field: "program_lead",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Program Lead
                    <SearchIcon
                        style={{ width: "15px", marginTop: "3px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "program_lead")}
                    />
                </div>
            ),
            minWidth: 140,
            sortable: true,
            flex: 1,
            headerClassName: "center-header",
            cellClassName: "left-cell",
        },
        {
            field: "collateral_type",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Collateral Type
                    <FilterAltIcon
                        style={{ width: "15px", marginTop: "3px", marginLeft: "3px" }}
                        onClick={(e) => handleFilterClick(e, "collateral_type")}
                    />
                </div>
            ),
            minWidth: 140,
            sortable: false,
            flex: 1,
            headerClassName: "center-header",
            cellClassName: "left-cell",
        },
        {
            field: "no_of_collaterals",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    # Collaterals
                </div>
            ),
            minWidth: 110,
            sortable: true,
            flex: 0.7,
            headerClassName: "center-header",
            cellClassName: "left-cell",
        },
        {
            field: "start_date",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Start Date
                </div>
            ),
            minWidth: 120,
            sortable: true,
            flex: 0.8,
            headerClassName: "center-header",
            cellClassName: "left-cell",
            renderCell: (params) =>
                params.row.start_date
                    ? new Date(params.row.start_date).toLocaleDateString("en-GB")
                    : "—",
        },
        {
            field: "end_date",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    End Date
                </div>
            ),
            minWidth: 120,
            sortable: true,
            flex: 0.8,
            headerClassName: "center-header",
            cellClassName: "left-cell",
            renderCell: (params) =>
                params.row.end_date
                    ? new Date(params.row.end_date).toLocaleDateString("en-GB")
                    : "—",
        },
        {
            field: "actions",
            headerName: "Actions",
            minWidth: 220,
            sortable: false,
            renderCell: (params) => {
                const row = params.row;

                // Rejected
                if (row.status === "rejected") {
                    return <Chip label="Rejected" color="error" size="small" />;
                }

                // Approved → show Assign button
                if (row.status === "approved") {
                    return (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleAssign(row)}
                        >
                            Assign to Designer
                        </Button>
                    );
                }

                // Pending → show radio buttons
                if (row.status === "pending_approval") {
                    return (
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name={`action-${row.id}`}
                                    onChange={() => handleAction(row.id, "approved")}
                                />
                                Approve
                            </label>

                            <label style={{ marginLeft: "10px" }}>
                                <input
                                    type="radio"
                                    name={`action-${row.id}`}
                                    onChange={() => handleAction(row.id, "rejected")}
                                />
                                Reject
                            </label>
                        </div>
                    );
                }

                // Assigned / Under Review / Completed
                return <Chip label={row.status} size="small" />;
            },
        },
        {
            field: "files",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Files
                </div>
            ),
            minWidth: 90,
            sortable: false,
            flex: 0.6,
            headerClassName: "center-header",
            cellClassName: "left-cell",
            renderCell: (params) => {
                const files = params.row.files?.filter((f) => f.file_name) || [];
                return (
                    <Chip
                        label={`${files.length} file${files.length !== 1 ? "s" : ""}`}
                        size="small"
                        color={files.length > 0 ? "primary" : "default"}
                        variant="outlined"
                        style={{ fontSize: "11px", height: "20px" }}
                    />
                );
            },
        },
        {
            field: "details",
            headerName: (
                <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    Details
                </div>
            ),
            minWidth: 90,
            flex: 0.4,
            sortable: false,
            headerClassName: "center-header",
            cellClassName: "left-cell",
            renderCell: (params) => (
                <img
                    onClick={() => handleOpen(params.row)}
                    style={{ width: "15px", cursor: "pointer" }}
                    src={process.env.PUBLIC_URL + "/Images/desc_icon.png"}
                    alt="details"
                />
            ),
        },
    ];

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const rowsWithSerial = rows.map((row, index) => ({
        ...row,
        id: row.id ?? index + 1,
    }));

    const showToast = (message, severity = "success") => {
        setToast({ open: true, message, severity });
    };

    const handleToastClose = () => {
        setToast({ ...toast, open: false });
    };

    // Render
    return (
        <>
            {downloadingFile && (
                <Alert severity="info" sx={{ mb: 2 }}>
                    Preparing download for <strong>{downloadingFile}</strong>. Please wait...
                </Alert>
            )}

            <div className="btns-container">
                <span className="clear-filter" onClick={clearFilters}>
                    Clear Filter
                </span>
            </div>

            <div className="datagrid-container" style={{ height: 500, width: "100%" }}>
                <DataGrid
                    rows={rowsWithSerial}
                    columns={columns}
                    loading={fetchLoading}
                    sortModel={sortModel}
                    onSortModelChange={(newModel) => setSortModel(newModel)}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 7 } },
                    }}
                    pageSizeOptions={[7, 10, 25]}
                    disableColumnMenu
                    sx={{
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#022278",
                            color: "white",
                            padding: "0px !important",
                        },
                        "& .MuiDataGrid-columnHeaderTitleContainer": {
                            textAlign: "left",
                        },
                        "& .MuiDataGrid-root": {
                            width: "100%",
                        },
                        "& .MuiDataGrid-sortIcon": {
                            color: "#fff",
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            width: "var(--DataGrid-rowWidth)",
                        },
                        "& .MuiDataGrid-row": {
                            backgroundColor: "white",
                            width: "calc(100% - 2px)",
                        },
                    }}
                    components={{
                        Footer: CustomFooter,
                    }}
                />

                {/* ── Details Modal ── */}
                <Modal
                    hideBackdrop
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="child-modal-title"
                    closeAfterTransition
                    aria-describedby="child-modal-description"
                    className="modal-container"
                >
                    <Box className="model">
                        <div className="model_heading">
                            <h5 className="paramodel">Details</h5>
                            <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                                Close
                            </span>
                        </div>
                        <hr />
                        <div className="program-modal-details">
                            {[
                                ["Market", modalRecord?.market],
                                ["Program Name", modalRecord?.program_name],
                                ["Program Lead", modalRecord?.program_lead],
                                ["Program Objective", modalRecord?.program_objective],
                                ["Program Type", modalRecord?.program_type],
                                ["Target Audience", modalRecord?.target_audience],
                                ["Collateral Type", modalRecord?.collateral_type],
                                ["No. of Collaterals", modalRecord?.no_of_collaterals],
                                [
                                    "Start Date",
                                    modalRecord?.start_date
                                        ? new Date(modalRecord.start_date).toLocaleDateString("en-GB")
                                        : "—",
                                ],
                                [
                                    "End Date",
                                    modalRecord?.end_date
                                        ? new Date(modalRecord.end_date).toLocaleDateString("en-GB")
                                        : "—",
                                ],
                                ["Notes", modalRecord?.notes],
                            ].map(([label, value]) => (
                                <div className="program-details-wrap" key={label}>
                                    <p className="program-details-header">{label}: </p>
                                    <p className="program-details-value">{value || "—"}</p>
                                </div>
                            ))}
                        </div>

                        {/* Files */}
                        <div className="program-details-wrap">
                            <p className="program-details-header">Files: </p>
                            <div className="files_wrap">
                                {modalRecord?.files?.filter((f) => f.file_name).length > 0 ? (
                                    modalRecord.files
                                        .filter((f) => f.file_name)
                                        .map((file) => (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                disabled={downloadingFile === file.file_name}
                                                class="close_btn_model download_btn"
                                                onClick={() =>
                                                    handleDownload(file.file_path, file.file_name)
                                                }
                                            >
                                                {file.file_name}
                                                <DownloadIcon fontSize="small" />
                                            </Button>
                                        ))
                                ) : (
                                    <p className="program-details-value">No files attached</p>
                                )}
                            </div>
                        </div>
                    </Box>
                </Modal>

                <Modal open={openAssignModal} onClose={() => setOpenAssignModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "30%",
                            left: "50%",
                            transform: "translate(-50%, -30%)",
                            width: "30vw",
                            bgcolor: "white",
                            p: 3,
                            borderRadius: 2,
                        }}
                    >
                        <Typography variant="h6" mb={2}>
                            Assign Designer
                        </Typography>

                        <List sx={{ maxHeight: "300px", overflowY: "auto" }}>
                            {designerList?.map((designer) => (
                                <ListItem key={designer.Enterprise_ID} disablePadding>
                                    <label style={{
                                        width: "100%",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "8px"
                                    }}>
                                        <input
                                            type="radio"
                                            name="designer"
                                            value={designer.Enterprise_ID}
                                            checked={selectedDesigner === designer.Enterprise_ID}
                                            onChange={() => setSelectedDesigner(designer.Enterprise_ID)}
                                            style={{ marginRight: "10px" }}
                                        />
                                        {designer.Enterprise_ID}
                                    </label>
                                </ListItem>
                            ))}
                        </List>

                        <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
                            <Button onClick={() => setOpenAssignModal(false)}>Cancel</Button>
                            <Button
                                variant="contained"
                                onClick={handleAssignSubmit}
                                disabled={assignLoading}
                            >
                                {assignLoading ? "Assigning..." : "Assign"}
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {/* Filter Popover */}
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleFilterClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    PaperProps={{
                        style: {
                            maxHeight: 300,
                            maxWidth: 250,
                            overflow: "auto",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 10,
                            paddingBottom: 10,
                        },
                    }}
                >
                    <Box sx={{ p: 0 }}>
                        <TextField
                            fullWidth
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{
                                "& .MuiInputBase-input": {
                                    fontSize: "0.7rem",
                                    padding: "3.5px 6px",
                                    textTransform: "capitalize",
                                },
                            }}
                        />
                        <List>
                            {filteredOptions.map((option, index) => {
                                const isSelected =
                                    selectedFilters[currentColumn]?.includes(option);
                                return (
                                    <ListItem
                                        button
                                        key={index}
                                        onClick={() => handleSelection(option, isSelected)}
                                        sx={{ padding: "0px", height: "22px" }}
                                    >
                                        <ListItemIcon style={{ minWidth: "0px", paddingRight: "5px" }}>
                                            {isSelected ? (
                                                <CheckBoxIcon
                                                    sx={{
                                                        width: "0.6em",
                                                        height: "0.6em",
                                                        "& path": { fill: "#1976d2" },
                                                    }}
                                                />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    sx={{ width: "0.6em", height: "0.6em" }}
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={option}
                                            primaryTypographyProps={{ style: { fontSize: "0.8rem" } }}
                                        />
                                    </ListItem>
                                );
                            })}
                        </List>
                        <Typography
                            onClick={handleReset}
                            style={{ cursor: "pointer", color: "#1976d2" }}
                        >
                            Reset
                        </Typography>
                    </Box>
                </Popover>
            </div>

            <Snackbar
                open={toast.open}
                autoHideDuration={3000}
                onClose={handleToastClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleToastClose}
                    severity={toast.severity}
                >
                    {toast.message}
                </MuiAlert>
            </Snackbar>
        </>
    );
};

export default CampaignDesignTable;